import { Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-draggable-box',
  templateUrl: './draggable-box.component.html',
  styleUrls: ['./draggable-box.component.css']
})

export class DraggableBoxComponent  {
  @Input() imgPath: any;
  @ViewChild('SlidingZoomBox', { static: true }) _slidingZoomBox!: ElementRef;
  @ViewChild('SlidingZoomContainer', { static: true }) _slidingZoomContainer!: ElementRef;
  @ViewChild('sliderBgImg') _sliderBgImg!: ElementRef<HTMLImageElement>;
  @Output() positionChanged = new EventEmitter<number>(); // Emit position
  
  zoomBoxStyle: any = { height: 0, width: 0, margintop: 0 };
  isDragging = false;
  currentX: number = 0;
  startX = 0;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  // OnStart() Function Used To Set Boolean Flag That Is Used To Stop Y-Axis Movement While Sliding...
  OnStart(event: MouseEvent | TouchEvent) {
    this.isDragging = true;
    this.startX = this.GetEventX(event) - this.currentX;
  }

  // OnEnd() Function Used To Set Boolean Flag That Is Used To Stop Y-Axis Movement While Sliding...
  @HostListener('document:mouseup')
  @HostListener('document:touchend')
  OnEnd() {
    this.isDragging = false;
  }
  
  // GetEventX() function is used to retrieve the X-Axis Position Of The Event.
  private GetEventX(event: MouseEvent | TouchEvent): number {
    // 1 - Ternary Statement Used To Extract And Return X-Axis Position Of The Event
    return (event instanceof MouseEvent) ? event.clientX : event.touches[0].clientX;
  }
  
  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:touchmove', ['$event'])
  onMove(event: MouseEvent | TouchEvent) {
    // 1 - If Clicking/Touching the slider, prevent y-axis movement...
    if (!this.isDragging) return;
    
    // 2 - Declare HTML References To Perform Calculations later in this function...
    const slidingZoomContainer = this._slidingZoomContainer.nativeElement;
    const slidingZoomBox = this._slidingZoomBox.nativeElement;
    
    // 3 - Determine The NEW Location Of The Sliding Box... 
    this.currentX = this.GetEventX(event) - this.startX;
    
    // 4 - Logic To Prevent Moving The 'Sliding-Zoom-Box' Outside Of The 'Sliding-Zoom-Container'...
    const minX = 0;
    const maxX = slidingZoomContainer.offsetWidth - slidingZoomBox.offsetWidth;
    this.currentX = Math.max(minX, Math.min(this.currentX, maxX));
    
    // 5 - Move The 'Sliding-Zoom-Box' On The X-Axis...
    this.renderer.setStyle(this._slidingZoomBox.nativeElement, 'left', `${this.currentX}px`);
    
    // 6 - Emit Event To Parent Component, Indicating The New Position Of The 'Silding-Zoom-Box'...
    this.positionChanged.emit(this.currentX) ; 
  }

  // OnResize(), This function is used to maintain proper 'sliding-zoom-box' sizing and positioning after
  // a changes screen orientation. This is required to match the sizing of the backgoround image...
  @HostListener('window:resize', ['$event'])
  OnResize(event: Event) {
    this.SetSlidingBox();
    this.CenterSlidingBox();
  }
  
  // OnImageLoad(), this function is called when the 'zoom-box-backgound-image' is loaded.
  // This function is required when the image source is retireved via URL 
  OnImageLoad(img: HTMLImageElement) {
    // 1 - If the image element exists then...
    if(img != null || img != undefined){
      // 2 - Build the sliding zoombox...
      this.SetSlidingBox();
      // 3- Position the sliding zoom box into the center of the background image...
      this.CenterSlidingBox();
    } 
  }

  // SetSlidingBox(), This function is used to establish the sizing of the sliding zoom box.
  // This function needs to be called after the background image is loaded or else it won't work,
  // the function should be called when the screen resolution changes (like when a phone is turned on it's side)
  SetSlidingBox() {
    // 1 -  Declare Variable To Reference Background Image Element. The backgound image size is 
    //      determined by the class "img-fluid", that class will size the image to fit the parent container. 
    const backgroundImage = this._sliderBgImg.nativeElement;

    // 2 -  Once we know that the backgound image is sized properly. Then we should have everything we need 
    //      to size the 'slidingZoomBoox'
    this.zoomBoxStyle = {
      boxMarginTop: backgroundImage.clientHeight * -1,  // ZOOM-BOX IS ASSIGN NEGATIVE MARGIN OF THE RENDERED IMAGE HEIGHT TO OVERLAY PERFECTLY...
      boxWidth: backgroundImage.clientWidth * 0.25,       // ZOOM-BOX IS 1/4 WIDTH OF THE RENDERED IMAGE...
      boxHeight: backgroundImage.clientHeight,            // ZOOM-BOX IS 1:1 HEIGHT IF THE RENDERED IMAGE...
    };
  }


  CenterSlidingBox() {
    // 1 -  Declare Variable To Reference Background Image Element. The backgound image size is 
    //      determined by the class "img-fluid", that class will size the image to fit the parent container. 
    const backgroundImage = this._sliderBgImg.nativeElement;

    // 2 - We use the variable 'currentX' to idicate how far (in pixels) to slide the box left to center on the screen. 
    this.currentX = ( this.zoomBoxStyle.boxWidth * 1.5);
      
    // 3 - Emit an event to the parent component indicating the position of the 'sliding-zoom-box'.
    this.positionChanged.emit(this.currentX) ; 
  }

}